var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tab',{attrs:{"name":"labels","label-key":"generic.labelsAndAnnotations"}},[_c('Labels',{attrs:{"mode":_vm.mode,"display-side-by-side":false},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }